import { useTranslation } from 'react-i18next';

interface MyButtonProperties {
  label: string;
  buttonType:
    | 'submit'
    | 'back'
    | 'error'
    | 'outline'
    | 'active-outline'
    | 'warning'
    | 'none'
    | 'primary-outline'
    | 'primary-outline-none'
    | 'gray';
  disableHoverEffect?: boolean;
  svgIcon?: JSX.Element;
  svgBackIcon?: JSX.Element;
  onClickFunc?: () => void;
  valueRequired?: boolean;
  notifyCount?: number | null;
  loading?: boolean;
  disableButton?: boolean;
  disableClass?: string;
  hoverLabel?: string;
  labelColorFill?: string;
  svgColorFill?: string;
}

/**
 * Shared button component
 */
function MyButton({
  label,
  buttonType,
  svgIcon,
  svgBackIcon,
  disableHoverEffect,
  onClickFunc,
  valueRequired,
  notifyCount,
  loading,
  disableClass,
  disableButton,
  hoverLabel,
  labelColorFill,
  svgColorFill,
}: MyButtonProperties) {
  const { i18n } = useTranslation();

  return (
    <div className="button-wrap" dir={i18n.dir()}>
      <button
        type="button"
        className={`${buttonType}-button ${disableHoverEffect ? '' : 'on-hover'} ${buttonType} ${disableClass}`}
        disabled={disableButton}
        onClick={onClickFunc}>
        {svgIcon && (
          <span style={{ width: '21px', height: '21px', color: svgColorFill }}>{svgIcon}</span>
        )}
        {label && <span style={{ marginInlineEnd: '4px', color: labelColorFill }}>{label}</span>}
        {svgBackIcon && <span style={{ width: '21px', height: '21px' }}>{svgBackIcon}</span>}
        {notifyCount && notifyCount > 0 ? (
          <span className="button-notifyCount">{notifyCount}</span>
        ) : (
          ''
        )}
        {valueRequired && <span className="value-required-indicator">*</span>}
      </button>
      {hoverLabel && <div className="hover-label">{hoverLabel}</div>}
      {loading && (
        <div className="button-loader-wrap">
          <div className="button-loader-container">
            <div className="button-loader" />
          </div>
        </div>
      )}
    </div>
  );
}

MyButton.defaultProps = {
  onClickFunc: null,
  disableHoverEffect: false,
  valueRequired: false,
  svgIcon: null,
  svgBackIcon: null,
  notifyCount: null,
  disableClass: null,
  loading: false,
  disableButton: false,
  hoverLabel: '',
  labelColorFill: '',
  svgColorFill: '',
};

export default MyButton;
